import * as RadixDialog from '@radix-ui/react-dialog'
import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { supportDialogScreenAtom } from '../atoms'

import { SupportScreen } from './support-screen'

import type { ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'
import type { ReactElement } from 'react'

type SupportDialogProps = {
  trigger?: ReactElement
} & ClassNameProps &
  DialogControlProps

export const SupportDialog: React.FC<SupportDialogProps> = ({
  open,
  onOpenChange,
  className,
  trigger,
}) => {
  const [, setSupportScreen] = useAtom(supportDialogScreenAtom)

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      setSupportScreen({ screen: 'tickets' })
    }
    onOpenChange?.(nextOpen)
  }

  return (
    <RadixDialog.Root modal={false} open={open} onOpenChange={handleOpenChange}>
      {trigger ? (
        <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>
      ) : undefined}
      <RadixDialog.Portal>
        <Panel className={className}>
          <PanelInner>
            <SupportScreen
              onOpenChange={(nextOpen) => onOpenChange?.(nextOpen)}
            />
          </PanelInner>
        </Panel>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}

const Panel = styled(RadixDialog.Content)`
  border: 1px solid var(--background-3);
  background: var(--background-1);
  box-shadow: 0 0 60px 0 rgba(0, 0, 0, 0.38);

  width: 360px;
  min-height: 100px;
  position: fixed;

  right: 10px;
  bottom: 38px;

  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  max-height: 600px;
`

const PanelInner = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;

  display: flex;
  flex-direction: column;
`
